import { Table } from "@chakra-ui/react";
import GenericTable from "../../../../../components/GenericTable";
import GenericTableElement from "../../../../../components/GenericTableElement";
import { SETTLEMENT_INVOICES_TABLE_COLUMNS } from "../../../../../config/tables";
import { Invoice } from "../../../../../types/types";

type Props = {
  invoices: Invoice[];
  isLoading: boolean;
};

const InvoicesTable = ({ invoices, isLoading }: Props): JSX.Element => {
  return (
    <GenericTable
      interactive
      isLoading={isLoading}
      columns={SETTLEMENT_INVOICES_TABLE_COLUMNS}
    >
      {invoices.map((item: Invoice, index: number) => (
        <Table.Row key={index}>
          {SETTLEMENT_INVOICES_TABLE_COLUMNS.map((column) => {
            return (
              <GenericTableElement
                key={`${index}-${column.key}`}
                value={item[column.key]}
                badge={"format" in column && column.format === "badge"}
                formatDatetimeColombian={
                  "format" in column && column.format === "datetime"
                }
                statusIcon={column.key === "erpSyncStatus"}
                formatNumber={
                  "format" in column && column.format === "currency"
                }
              />
            );
          })}
        </Table.Row>
      ))}
    </GenericTable>
  );
};

export default InvoicesTable;
